import { useParams, Link } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '@lpr/ui';

export default function ReportConfirmationPage() {
  const { reportId } = useParams<{ reportId: string }>();

  return (
    <div className="min-h-screen flex items-center justify-center px-4 py-12">
      <Card variant="v4" className="w-full max-w-lg text-center">
        <CardHeader>
          <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-lpr-teal/10">
            <svg className="h-8 w-8 text-lpr-teal" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75" />
            </svg>
          </div>
          <CardTitle className="text-2xl">Check Your Email</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <p className="text-text-secondary">
            Your property report is being generated. We'll send you an email with a link to view it once it's ready.
          </p>

          {reportId && (
            <Link
              to={`/report/${reportId}`}
              className="inline-block mt-4 text-lpr-teal hover:underline font-medium"
            >
              View Report Now
            </Link>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
